import styled from 'styled-components';

const AboutWrapper = styled.div`
  font-size: 17px;
  line-height: 1.8;
  color: rgb(0,0,0,.8);
  font-family:"quicksand", serif;

   @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

function About() {
  return (
    <AboutWrapper>
      <p>
        I'm a recent Computer Science graduate from Oregon State University with a focus on Full Stack Web Development.
        <br></br>
        I am currently searching for a full-time software engineering role where I can apply my skills while continously learning.
      </p>
    </AboutWrapper>
  )
}

export default About;